// Event system for cross-component communication

type EventCallback = (data?: any) => void;

class EventEmitter {
  private events: Map<string, EventCallback[]> = new Map();

  on(event: string, callback: EventCallback) {
    if (!this.events.has(event)) {
      this.events.set(event, []);
    }
    this.events.get(event)!.push(callback);
  }

  off(event: string, callback: EventCallback) {
    const callbacks = this.events.get(event);
    if (callbacks) {
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    }
  }

  emit(event: string, data?: any) {
    const callbacks = this.events.get(event);
    if (callbacks) {
      callbacks.forEach(callback => callback(data));
    }
  }
}

export const eventEmitter = new EventEmitter();

// Event names
export const EVENTS = {
  TEAMS_UPDATED: 'teams:updated',
  TEAM_CREATED: 'teams:created',
  TEAM_DELETED: 'teams:deleted',
  TEAM_UPDATED: 'teams:team-updated',
  TEAM_FOLDERS_UPDATED: 'team-folders:updated',
  FOLDERS_UPDATED: 'folders:updated',
  WORKFLOWS_UPDATED: 'workflows:updated',
  // Knowledge Base events
  KB_COLLECTIONS_UPDATED: 'kb:collections-updated',
  KB_COLLECTION_CREATED: 'kb:collection-created',
  KB_COLLECTION_DELETED: 'kb:collection-deleted',
};
